class SorryController {
  constructor($rootScope, AuthService, $timeout) {
    this.name = "sorry";
    this.$rootScope = $rootScope;
    this.$auth = AuthService;
    this.$timeout = $timeout;
  }
}

SorryController.$inject = ["$rootScope", "auth", "$timeout"];

export default SorryController;



// WEBPACK FOOTER //
// ./client/app/common/sorry/sorry.controller.js